import { Dayjs } from "dayjs";
import { PaymentMethod } from "./Payment";
import { Product } from "./Product";
import { Purchase } from "./Purchase";
import { Source } from "./Source";

export interface Transaction {
    id: ID;
    amount: number;
    balance: number;
    createdAt: Dayjs;
    createdBy: {
        id: ID;
    };
    currency: string;
    earning: number;
    method: PaymentMethod;
    source: Source;
    type: string;
    seller: {
        id: ID;
    };
    items: TransactionItem[];
    purchase?: Purchase; // Only given when context=report
    payout?: {
        id: ID;
        createdAt?: Dayjs;
    };
    remoteTransactions?: RemoteTransaction[];
    reconcile: { id: ID };
    comment?: string;
    meta?: { end?: string; start?: string };
}

export interface TransactionItem {
    orderItem: { id: ID; product: Product };
    commission: number;
    commissionSplitAmount?: CommissionSplitAmount;
    gross: number;
    id: ID;
    net: number;
    realizableAmount: number;
    realizedAt: Dayjs;
    taxFee: number;
    fees: TransactionItemFee[];
    source: Source;
    method: PaymentMethod;
}

export interface TransactionItemFee {
    name: string;
    amount: number;
}

export interface RemoteTransaction {
    id: ID;
    amount: number;
    value: number;
    gateway: string; // Stripe, Authorize.net, etc.
    remoteCard: ID;
    remoteID: string; // ch_<something>
    remoteSystem: string; // 'stripe', 'authorize.net', etc.
    cardSummary: {
        brand: string;
        expMonth: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
        expYear: number;
        funding: "credit" | "debit";
        id: ID;
        last4: number;
        name: string | null;
        postcode: string;
    };
    type: string;
}

export interface CommissionSplitAmount {
    creditCard: number;
    gateway: number;
    offline: number;
    seller: number;
    traveler: number;
    ware?: number;
}

export interface TransactionItemFee {
    name: string;
    amount: number;
}

export enum TransactionType {
    PURCHASE = "purchase",
    REFUND = "refund",
    REFUND_COMMISSION = "refund_commission",
    DEPOSIT = "deposit",
    BALANCE = "balance",
    PURCHASE_AFFILIATE = "purchase_affiliate",
    REDEEM = "redeem",
    PLUGIN_FEE = "plugin_fee",
    DISPUTE = "dispute",
    PARTNER_RECONCILE_AUTO = "partner_reconcile_auto",
    PARTNER_RECONCILE_MANUAL = "partner_reconcile_manual",
    PARTNER_PURCHASE = "partner_purchase",
    STRIPE_PAYDOWN = "stripe_paydown",
}
